<template>
  <v-app>
    <SideBar />
    <br />
    <v-content>
      <div class="text-center">
        <v-dialog v-model="progressBar" width="100" hide-overlay>
          <v-progress-circular
            :size="60"
            color="primary"
            indeterminate
            align-center
            justify-center
          >
          </v-progress-circular>
        </v-dialog>
      </div>
      <v-container>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card color="#1b5e20">
              <v-col class="text-right">
                <v-btn
                  @click.native="close"
                  icon
                  rounded
                  color="white"
                  outlined
                  elevation="5"
                  large
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-card>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  label="E-mail"
                  required
                  append-icon="mdi-email"
                >
                </v-text-field>
                <v-text-field
                  v-model="password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="passwordRules"
                  :type="showPassword ? 'text' : 'password'"
                  label="Password"
                  hint="At least 6 characters"
                  counter
                  @click:append="showPassword = !showPassword"
                ></v-text-field>

                <div class="text-xs-center">
                  <v-btn
                    color="#1b5e20 white--text"
                    :disabled="!valid"
                    @click="submit"
                    onloadstart="loading"
                  >
                    Login
                    <v-icon right color="white">mdi-lock-open</v-icon>
                  </v-btn>
                </div>
              </v-form>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import SideBar from "../components/SideBar";
export default {
  name: "login",
  components: {
    SideBar,
  },
  data() {
    return {
      valid: true,
      email: "demo@indorobotika.co.id",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /([a-zA-Z0-9_]{1,})(@)([a-zA-Z0-9_]{2,}).([a-zA-Z0-9_]{2,})+/.test(v) ||
          "E-mail must be valid",
      ],
      showPassword: false,
      password: "demo123",
      passwordRules: [
        (v) => !!v || "Password required.",
        (v) => (v && v.length >= 6) || "Min 6 characters",
      ],
      progressBar: false,
    };
  },

  computed: {
    ...mapGetters({
      user: "auth/user",
      prevUrl: "prevUrl",
      setting: "setting/setting",
    }),
  },
  methods: {
    ...mapActions({
      setAlert: "alert/set",
      setAuth: "auth/set",
      setSetting: "setting/set",
    }),
    submit() {
      if (this.$refs.form.validate()) {
        this.progressBar = true;
        let formData = {
          email: this.email,
          password: this.password,
        };

        this.axios
          .post("/login", formData)
          .then((response) => {
            let { data } = response.data;
            this.setAuth(data);
            this.store_setting();
            if (this.user.id > 0) {
              this.setAlert({
                status: true,
                color: "success",
                text: "Login success",
              });
              if (this.prevUrl.length > 0) this.$router.push(this.prevUrl);
              this.close();
            } else {
              this.setAlert({
                status: true,
                color: "error",
                text: "Login failed",
              });
            }
          })
          .catch((error) => {
            let { data } = error.response;
            this.setAlert({
              status: true,
              color: "error",
              text: data.message,
            });
          });
      }
    },
    close() {
      return this.$router.push({ path: "/" });
    },
    store_setting() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      let url = "/store-setting";
      this.axios
        .get(url, config)
        .then((response) => {
          let { data } = response.data;
          this.setSetting(data);
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
  },
};
</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}
</style>
